import React from 'react';

   const Home = React.lazy(() => import('./Layoutt'));
   const Terms = React.lazy(() => import('./components/Terms'));
   const NotFound =  React.lazy(() => import('./components/Page404'));

const routes = [
  { path:'/', exact: true, name: 'Home', component:<Home  /> },
  { path:'/tncs', name: 'Terms', component:<Terms /> },
  { path:'*', name:'404 Page', component:<NotFound />}, 
];

export default routes;
